import React,{useState,createRef,useEffect } from 'react';
// import { Container, Input, Form,FormGroup,Row,Col, } from 'reactstrap';
import { useSelector, useDispatch } from "react-redux";
import { hideCOPYProj, showLoader } from '../redux/ctrl/ctrlActions';
import { copyProject } from '../redux/project/projActions';
import toastr from 'toastr';
import "toastr/build/toastr.min.css";
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Grid, TextField } from '@mui/material';
import Paper from '@mui/material/Paper';
import Draggable from 'react-draggable';
 import getDt from '../../utils';
 import { useTranslation } from 'react-i18next';
 
function PaperComponent(props) {
    return (
        <Draggable
            handle="#draggable-dialog-title"
           // cancel={'[class*="MuiDialogContent-root"]'}
        >
            <Paper {...props} />
        </Draggable>
    );
}

const CopyProject = () => {
    let errCnt = 0;
    const ctrl =  useSelector((state) => state.ctrl)
    const profile =  useSelector((state) => state.profile);
    const [projectName, setProjectName] = useState("");
    const newProjName = createRef(null);
    const [errors, setErrors] = useState({});
    const dispatch=useDispatch()
    const profileState=useSelector((state)=>state.profile)
    const { t, i18n } = useTranslation();
    const handleClose =(val) =>{
        setErrors({})
        setProjectName("")
        dispatch(hideCOPYProj(val));
        
    }

    const handleChange = (e) =>{
        e.preventDefault();
        //console.log(e.target.value)
        //newProjName=e.target.value;
        //console.log(newProjName)
    }
    

    const copyProj = () =>{
        const copyProjData = {
             start_date:getDt(new Date()),
            old_project_id: ctrl.data.project_id,
            new_project_name: projectName,
            created_by: profile.email,
            //  prjCnt: profile.appAcc[0].project_count,
            eid: profile.email,
            owner_name: profile?.givenName+" "+profile?.familyName
        }
        valFields();
        if(errCnt===0)
            {
                dispatch(hideCOPYProj(false));
                dispatch(showLoader(true))
                setTimeout(()=>{dispatch(copyProject(copyProjData))},1000)
            }
    }

    const valFields = () =>{
        const errors = {};
        if (!projectName){
            errors.cpyPrjName = "**Project Name is required";
            errCnt+=1;            
        }
        if (!ctrl.data.tier || ctrl.data.tier === 0){
            toastr.error(t('Please update Project Tier of Parent Project before copying.'));
            errCnt+=1;
        }
        setErrors(errors);
    }

   
    return(
        <>
            <Dialog open={ctrl.copyProject} onClose={() => { }} PaperComponent={PaperComponent}
                aria-labelledby="draggable-dialog-title" className='muiForm-Modal'>
                {/* <DialogTitle className="model-header model-title" id="draggable-dialog-title">Copy Project :  <input style={{ width: '20pc', border: '0px', backgroundColor: 'transparent', outline: 'none' }} value={ctrl.data.project_name + ' - ' + ((ctrl.data.project_number || [].length > 15) ? ctrl.data.project_number.substring(0, 15) + '...' : ctrl.data.project_number)} ></input> </DialogTitle> */}
                <DialogTitle className="model-header model-title" id="draggable-dialog-title"> {t('Copy Project')} : <input style={{ width: '20pc', border: '0px', backgroundColor: 'transparent', outline: 'none' }} value={'' + ((ctrl?.data?.project_name?.length > 15) ? (ctrl?.data?.project_name.substring(0,15) + '...') : ctrl?.data?.project_name ) + ' - ' + ctrl?.data?.project_number } ></input> </DialogTitle>
                <DialogContent className="copy-project-model-body">
                    <Grid container>
                        <Grid>
                            <TextField label={t('Project Name')} size='small' required name='cpyPrjName' innerRef={newProjName} id='cpyPrjName' type='text' inputProps={{ maxLength: 100 }} onChange={(e) => setProjectName(e.target.value)} error={errors.cpyPrjName} />
                            {/* <Input bsSize='sm' ></Input> */}
                            {/* <p className="text-danger">{errors.cpyPrjName}</p> */}
                        </Grid>
                    </Grid>
              </DialogContent>
              <DialogActions className="copy-project-model-footer"  style={{ paddingRight: "16px" }}>
            <Button outline color="success" onClick={() => handleClose(false)}>
            {t('Cancel')}
            </Button>
            {/* <Button className="sbtn btn btn-secondary" onClick={(e) =>copyProj()} > */}
            <Button className="sbtn btn btn-secondary" onClick={(e) =>copyProj()} disabled={profileState?.capb?.findIndex((o)=>o.PWSCPPRJ==='Y')>=0? false:true} >
            <span>{t('Create')} </span>
            </Button>                
            </DialogActions>
            </Dialog>
        </>
    )
}

export default CopyProject;